import { combineReducers } from 'redux';

import { State, Type } from '../actions/utils';

import initialState from './initial';
import { failedDefaults, requestedDefaults, succeededDefaults } from './utils';

const details = (state: any = initialState.accountApplications.details, action: any) => {
  switch (action.type) {
    case State.actionRequested(Type.GET_ACCOUNT_APPLICATION):
      return requestedDefaults(state);
    case State.actionSucceeded(Type.GET_ACCOUNT_APPLICATION):
      return succeededDefaults(state, action);
    case State.actionFailed(Type.GET_ACCOUNT_APPLICATION):
      return failedDefaults(state, action);
    case State.actionSucceeded(Type.LOGOUT):
    case State.actionCleared(Type.GET_ACCOUNT_APPLICATION):
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
      return initialState.accountApplications.details;
    default:
      return state;
  }
};

const deleteDocument = (state: any = initialState.accountApplications.deleteDocument, action: any) => {
  switch (action.type) {
    case State.actionRequested(Type.DELETE_ACCOUNT_APPLICATION_DOCUMENT):
      return requestedDefaults(state);
    case State.actionSucceeded(Type.DELETE_ACCOUNT_APPLICATION_DOCUMENT):
      return succeededDefaults(state, action);
    case State.actionFailed(Type.DELETE_ACCOUNT_APPLICATION_DOCUMENT):
      return failedDefaults(state, action);
    case State.actionSucceeded(Type.LOGOUT):
    case State.actionCleared(Type.DELETE_ACCOUNT_APPLICATION_DOCUMENT):
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
      return initialState.accountApplications.deleteDocument;
    default:
      return state;
  }
};

const cancelDocument = (state: any = initialState.accountApplications.cancelDocument, action: any) => {
  switch (action.type) {
    case State.actionRequested(Type.CANCEL_ACCOUNT_APPLICATION_DOCUMENT):
      return requestedDefaults(state);
    case State.actionSucceeded(Type.CANCEL_ACCOUNT_APPLICATION_DOCUMENT):
      return succeededDefaults(state, action);
    case State.actionFailed(Type.CANCEL_ACCOUNT_APPLICATION_DOCUMENT):
      return failedDefaults(state, action);
    case State.actionSucceeded(Type.LOGOUT):
    case State.actionCleared(Type.CANCEL_ACCOUNT_APPLICATION_DOCUMENT):
    case State.actionSucceeded(Type.SWITCH_ACCOUNT):
    case Type.ADD_NEW_ACCOUNT_TYPE:
      return initialState.accountApplications.cancelDocument;
    default:
      return state;
  }
};

export const accountApplicationReducers = combineReducers({
  details,
  deleteDocument,
  cancelDocument,
});
